import { ca } from '@cian/analytics';

export function trackSaveToFolder(offerId: number, position: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'add_to_collection',
    label: '',
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position,
      },
    ],
  });
}
